/*
 * @Author: Teemo Ding
 * @Date: 2021-12-02 11:24:56
 * @LastEditTime: 2023-02-03 13:26:33
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/CreateNewOrder/index.tsx
 */
import { Button, DropDown, Menu, MenuItem } from '@/src/components/Antd';
import NoPermission from '@/src/components/NoPermission';
import ModalHOC from '@/src/constrains/ModalHOC';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  applyDiscount,
  deleteOrder,
  getCreateFees,
  getCreateOrderDetail,
  getSalesChannelConfig,
  getVouchers,
  orderCreateNotify,
  placeCreateOrder,
  saveCreateOrder,
  senderPage,
} from '@/src/request/order/createOrder';
import { getLanguageList } from '@/src/request/salesChannel/multiLanguage';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import { IPaymentStatus, IOrderStatus } from '@/src/types/common/order';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { modal } from '@/src/utils/Modal';
import { useRequest } from 'ahooks';
import { Form, Spin, message } from 'antd';
import { get, isNumber } from 'lodash';
import React, { Fragment, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import Layout from 'src/layout/DetailPageLayout';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import { NEW, moreThanOneExclusiveCodeErrorCodes } from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { ICategory } from 'src/types/common/template';
import Customer from '../../Components/Customer';
import Discount from '../../Components/Discount';
import OrderInfoRight from '../../Components/OrderInfoRight';
import Products from '../../Components/Products';
import SalesChannel from '../../Components/SalesChannel';
import SendTemplate from '../../Components/SendTemplate';
import Voucher from '../../Components/Voucher';
import { discountCalculate } from '../../common';
import { paymentStatusText, statusText } from '../OrderList/config';
import css from './css.module.less';
import { breadcrumbData } from './tools';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
interface IParams {
  uuid: string;
}

const formName = 'createNewOrder';

const permissions = () => {
  const canPlaceOrder = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCreation,
        operation: EnumOperation.place_order,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCreation,
        operation: EnumOperation.create_edit_order,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCreation,
        operation: EnumOperation.delete_order_portal_created_order,
      }),
    ],
  });

  const canViewDetail = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.AllOrders,
        operation: EnumOperation.view_order_details_page,
      }),
    ],
  });
  const canNotifyCustomer = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderCartTemplate,
        operation: EnumOperation.notify_customer,
      }),
    ],
  });
  return {
    canPlaceOrder,
    canCreate,
    canDelete,
    canViewDetail,
    canNotifyCustomer,
  };
};
const CreateNewOrder = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    canPlaceOrder,
    canCreate,
    canDelete,
    canViewDetail,
    canNotifyCustomer,
  } = permissions();
  const history = useHistory();
  const [form] = Form.useForm();
  const { modalOp } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
  } = modalOp;
  const [dbUuid, setDbUuid] = useState(''); //dataBaseUuid
  const [customer, setCustomer] = useState(); //选取的用户
  const [salesChannelUuid, setSalesChannelUuid] = useState(''); //选取的salesChannel uuid
  const salesChannels = useSelector(getSalesChannels()) || [];
  const currentSalesChannel = salesChannels.find(
    (i) => i.uuid === salesChannelUuid,
  );
  const decimalPosition = isNumber(get(currentSalesChannel, 'decimalPosition'))
    ? get(currentSalesChannel, 'decimalPosition')
    : 2;
  const scTimezoneUTC = get(currentSalesChannel, 'timezoneGmt') || '';
  const [hasModified, setHasModified] = useState(false); //页面表单是否修被改过
  const [customerDetail, setCustomerDetail] = useState<any>(); //结构{ recipientEmail, recipientName, recipientPhoneNo, shippingAddress，billingAddress, buyerEmail, buyerName, buyerPhoneNo }
  const [languageCode, setLanguageCode] = useState();
  const [buyerInfo, setBuyerInfo] = useState<any>(); //购买人信息，结构：{customerInfoFields:[],consignee:{}}
  const [billingAddressDetail, setBillingAddressDetail] = useState();
  const [orderStatus, setOrderStatus] = useState(); //订单状态
  const [orderNo, setOrderNo] = useState(); //订单号
  const [paymentStatus, setPaymentStatus] = useState(); //支付状态
  const [recipientInfo, setRecipientInfo] = useState(); //收货人信息，结构：{deliveryInfo: {}, recipientFields: [],}
  const [invoice, setInvoice] = useState();
  const [parcelSender, setParcelSender] = useState();
  const [summary, setSummary] = useState({});
  const [showInvoice, setShowInvoice] = useState(false);
  const { uuid: orderUuid }: IParams = useParams();

  const { run: _applyDiscount } = useRequest((data) => applyDiscount(data), {
    manual: true,
    throttleInterval: 500,
    onSuccess: (res) => {
      const {
        discountSelections = [],
        products,
        currency = '',
        discountCodes,
        promotionChanged,
        promptMsg,
      } = res;
      setSummary({
        ...summary,
        currency,
      });
      if (promotionChanged) {
        message.warning(promptMsg);
      }

      const discountSelectionsAll = (discountSelections || []).map((item) => ({
        ...item,
        ...(get(item, 'giftSelection') && {
          giftSelection: {
            ...item.giftSelection,
            ...(get(item, 'giftSelection.products') && {
              products: get(item, 'giftSelection.products', []).map(
                (product) => {
                  product.children = null;
                  return {
                    ...product,
                    //给discount加一个唯一的key
                    keyUuid:
                      get(item, 'discount.uuid') +
                      get(product, 'productUuid') +
                      get(product, 'uuid'),
                  };
                },
              ),
            }),
          },
        }),
      }));

      //给discountProduct加一个唯一的key，因为products.productUuid不唯一，products.uuid也不唯一，所以用randomNumber
      const productsAll = products.map((item) => ({
        ...item,
        keyUuid: randomNumber(),
      }));
      const values = form.getFieldsValue();
      const createOrderData = buildData(values);
      createOrderData.products = products;
      createOrderData.discountCodes = discountCodes;
      _getCreateFees(createOrderData);
      form.setFieldsValue({
        products: productsAll,
        discountCodes,
        discountSelections: discountSelectionsAll,
      });
    },
    onError: (e: any) => {
      const discountCodes = form.getFieldValue('discountCodes') || [];
      const { errorCode } = e;
      if (moreThanOneExclusiveCodeErrorCodes.includes(errorCode)) {
        discountCodes.pop();
        form.setFieldsValue({
          discountCodes,
        });
      }
    },
  });

  const { run: _orderCreateNotify } = useRequest(
    (data) => orderCreateNotify(data),
    {
      manual: true,
      onSuccess: () => {
        setShowModal(false);
        message.success(getI18n('allOrders.createneworder.notificationSend'));
      },
    },
  );

  const { run: _getSender } = useRequest(
    (currencySalesChannelUuid) =>
      senderPage({
        salesChannelUuid: currencySalesChannelUuid,
      }),
    {
      manual: true,
      onSuccess: (data) => {
        setParcelSender(data);
      },
    },
  );
  const { run: _getVouchers, data: vouchers = [] } = useRequest(
    (data) => getVouchers(data),
    {
      manual: true,
    },
  );
  const { run: _deleteOrder } = useRequest(
    (orderUuid) => deleteOrder(orderUuid),
    {
      manual: true,
      onSuccess: (vouchers) => {
        history.push('/orderList');
      },
    },
  );
  const { run: _getSalesChannelConfig } = useRequest(
    (salesChannelUuid) => getSalesChannelConfig({ salesChannelUuid }),
    {
      manual: true,
      onSuccess: (res) => {
        setShowInvoice(res.showInvoice);
      },
    },
  );
  const { loading: getCreateOrderDetailLoading } = useRequest(
    () => getCreateOrderDetail(orderUuid),
    {
      ready: orderUuid !== NEW && canViewDetail,
      onSuccess: (res) => {
        const {
          products,
          discountCodes,
          salesChannel,
          salesChannelLanguage,
          salesRepresentative,
          customerVO,
          orderRecipient,
          recipientEmail,
          recipientName,
          logisticsMethod,
          recipientPhoneNo,
          shippingAddress,
          buyerName,
          buyerPhoneNo,
          buyerEmail,
          billingAddressSimplify,
          orderBuyer,
          orderBillingAddress,
          orderStatus,
          orderNo,
          paymentStatus,
          voucherUuids,
          invoice,
          showInvoice,
          parcelSender,
          uuid,
        } = res;
        if (
          [
            IOrderStatus.ACTIVE,
            IOrderStatus.COMPLETED,
            IOrderStatus.SUSPENDED,
            IOrderStatus.CANCELLED,
          ].includes(orderStatus)
        ) {
          history.push(`/order/${uuid}`);
        }
        setShowInvoice(showInvoice);
        form.setFieldsValue({
          products,
          discountCodes,
          salesChannel,
          salesRepresentative,
          languageCode: salesChannelLanguage,
          voucherUuids,
        });
        setSalesChannelUuid(salesChannel.uuid);
        setOrderNo(orderNo);
        setDbUuid(get(salesChannel, 'customerDatabase.uuid'));
        _getLanguageList(salesChannel.uuid);
        setCustomer(customerVO);
        setInvoice(invoice);
        if (customerVO) {
          setRecipientInfo(orderRecipient);
          setOrderStatus(orderStatus);
          setPaymentStatus(paymentStatus);
          setBuyerInfo({
            customerInfoFields: orderBuyer.customerInfoFields,
            consignee: orderBillingAddress.consignee,
          });
          setParcelSender(parcelSender);
          setCustomerDetail({
            recipientEmail,
            recipientName,
            recipientPhoneNo,
            shippingAddress,
            buyerName,
            buyerPhoneNo,
            buyerEmail,
            logisticsMethod,
            billingAddress: billingAddressSimplify,
          });
          _getVouchers({
            salesChannelUuid: salesChannel.uuid,
            customer: customerVO,
          });
        }
        const data = {
          ...res,
          salesChannelUuid: salesChannel.uuid,
          customer: customerVO,
          products,
          voucherUuids: voucherUuids,
          discountCodes: discountCodes.length ? discountCodes : null,
        };
        _applyDiscount(data);
      },
    },
  );

  const { run: _getLanguageList, data: availableLanguage = [] } = useRequest(
    (data) => getLanguageList(data),
    {
      manual: true,
      onSuccess: (res) => {
        const primaryLanguage = res.filter((o) => o.primary);
        if (primaryLanguage[0]) {
          form.setFieldsValue({ languageCode: primaryLanguage[0] });
          setLanguageCode(primaryLanguage[0].tag);
        }
      },
    },
  );

  const { run: _saveCreateOrder } = useRequest(
    (data) => saveCreateOrder(data),
    {
      manual: true,
      onSuccess: (res) => {
        message.success(getI18n('general.savesuccess'));
        setHasModified(false);
        if (orderUuid == NEW && res.uuid) {
          history.replace(`/orderCreate/${res.uuid}`);
        }
      },
    },
  );
  const { run: _placeCreateOrder } = useRequest(
    (data) => placeCreateOrder(data),
    {
      manual: true,
      onSuccess: (res) => {
        const { paymentStatus } = res || {};
        setHasModified(false);
        setShowModal(false);
        setPaymentStatus(paymentStatus);
        if (orderUuid == NEW && res.uuid) {
          history.replace(`/orderCreate/${res.uuid}`);
        }
      },
    },
  );

  const {
    run: _getCreateFees,
    data: {
      deliveryFee: { shippingName = '', formattedDeliveryFee = '' } = {},
    } = {},
  } = useRequest((data) => getCreateFees(data), {
    manual: true,
    onSuccess: (res) => {
      const {
        tax: { taxes = [] },
        totalAmount,
        formattedSutTotalPrice,
        formattedDiscountPrice,
        formattedTotalPrice,
      } = res || {};

      setSummary({
        ...summary,
        totalAmount,
        formattedSutTotalPrice,
        formattedDiscountPrice,
        formattedTotalPrice,
        taxes: taxes || [],
      });
    },
  });

  const handleApplyDiscount = (combineData?) => {
    const values = form.getFieldsValue();
    const discountCodes = form.getFieldValue('discountCodes') || [];
    // console.log('discountCodes', discountCodes);
    const data = {
      ...buildData({ ...values, discountCodes }),
      ...combineData,
    };
    if ((data.products || []).length) {
      _applyDiscount(data);
    } else {
      form.setFieldsValue({
        discountSelections: [],
      });
      setSummary({
        ...summary,
        formattedDiscountPrice: '0.00',
        formattedSutTotalPrice: '0.00',
        formattedTotalPrice: '0.00',
      });
    }
  };

  const beforeGoBack = () => {
    history.push('/orderList');
  };

  const onValuesChange = (values, allValues) => {
    setHasModified(true);
    if (Object.keys(values).includes('salesChannel')) {
      //切换salesChannel时清空页面上的内容
      setSalesChannelUuid(get(values, 'salesChannel.uuid'));
      setDbUuid(get(values, 'salesChannel.customerDatabase.uuid'));
      _getLanguageList(get(values, 'salesChannel.uuid'));
      _getSalesChannelConfig(get(values, 'salesChannel.uuid'));
      _getSender(get(values, 'salesChannel.uuid'));
      form.setFieldsValue({
        products: [],
        discountSelections: [],
        voucherUuids: [],
      });
      setCustomer(null);
      setCustomerDetail(null);
      setBuyerInfo(null);
      setBillingAddressDetail(null);
      setRecipientInfo(null);
      setInvoice(null);
      setSummary({});
    }
    if (Object.keys(values).includes('products')) {
      //products有变化时重新计算discount
      handleApplyDiscount({ products: get(values, 'products') });
    }
    // if (
    //   Object.keys(values).includes('voucherUuids') ||
    //   Object.keys(values).includes('discountSelections')
    // ) {
    //   const createOrderData = buildData(allValues);
    //   _getCreateFees(createOrderData);
    // }
    if (Object.keys(values).includes('voucherUuids')) {
      //voucher有变化时重新计算discount
      const d = { voucherUuids: get(values, 'voucherUuids') };
      handleApplyDiscount(d);
      // const createOrderData = buildData(allValues);
      // _getCreateFees(createOrderData);
    }
    if (Object.keys(values).includes('discountSelections')) {
      //当选择的礼品有变化时，重新计算税费等价格
      const createOrderData = buildData(allValues);
      _getCreateFees(createOrderData);
    }

    if (Object.keys(values).includes('languageCode')) {
      setLanguageCode(values.languageCode.tag);
    }
  };

  const buildData = (data) => {
    //处理order相关数据
    const {
      salesChannel,
      languageCode,
      products,
      discountSelections,
      voucherUuids,
      discountCodes,
      salesRepresentative,
      notification,
    } = data;
    const { deliveryInfo, recipientFields = [] } = recipientInfo || ({} as any);
    const allSelectedGift = discountCalculate(discountSelections || []);
    const createOrderData = {
      customer: customer,
      uuid: orderUuid === NEW ? '' : orderUuid, //NEW说明是新建
      salesChannelUuid: (salesChannel || {}).uuid,
      languageCode: (languageCode || {}).tag,
      discountCodes,
      products,
      salesRepresentative,
      voucherUuids,
      buyer: buyerInfo,
      deliveryInfo,
      invoice,
      recipientFields,
      parcelSender,
      notification,
      ...allSelectedGift,
    };
    return createOrderData;
  };

  const buildCustomerData = () => {
    const values = form.getFieldsValue();
    const {
      salesChannel,
      languageCode,
      products,
      discountSelections,
      voucherUuids,
      discountCodes,
    } = values;
    const allSelectedGift = discountCalculate(discountSelections || []);
    const createOrderData = {
      customer: customer,
      uuid: orderUuid === NEW ? '' : orderUuid,
      salesChannelUuid: salesChannel.uuid,
      languageCode: languageCode.tag,
      discountCodes,
      products,
      voucherUuids,
      orderRecipient: recipientInfo || '',
      ...allSelectedGift,
    };
    return createOrderData;
  };

  const onFinish = (values) => {
    const discountCodes = form.getFieldValue('discountCodes') || [];
    const data = buildData({ ...values, discountCodes });
    _saveCreateOrder(data);
  };

  const handlePlaceOrderConfirm = (dataMessage) => {
    //placeOrder确认弹窗
    const values = form.getFieldsValue();
    const discountCodes = form.getFieldValue('discountCodes') || [];
    const sendTo = get(dataMessage, 'sendTo') || [];
    const notification =
      {
        viaEmail: sendTo.includes('Email'),
        viaSms: sendTo.includes('Mobile'),
        smsTemplateUuid: dataMessage.messageTemplate,
        emailTemplateUuid: dataMessage.emailTemplate,
      } || {};
    const data = buildData({
      ...values,
      discountCodes,
      notification,
    });
    _placeCreateOrder(data);
  };
  const handlePlaceOrder = () => {
    const discountSelections = form.getFieldValue('discountSelections') || [];
    console.log('discountSelections', discountSelections);
    let hasDiscountAllSelected = true;
    discountSelections.forEach((i) => {
      if (hasDiscountAllSelected && get(i, 'giftSelection.selectable')) {
        const userSelected =
          get(i, 'giftSelection.userSelection') === 'Confirmed';
        hasDiscountAllSelected = userSelected;
      }
    });

    setWidth(600);
    setShowModal(true);
    setModalTitle(getI18n('allOrders.createneworder.viewDetail_topright_btn'));
    setModalContent(
      <SendTemplate
        buyerEmail={(customerDetail || {}).buyerEmail}
        buyerPhoneNo={(customerDetail || {}).buyerPhoneNo}
        onConfirm={handlePlaceOrderConfirm}
        onModalCancel={onModalCancel}
        okText={getI18n('allOrders.createneworder.viewDetail_topright_btn')}
        category={ICategory.StoreCreditIssued}
        salesChannelUuid={salesChannelUuid}
        {...(hasDiscountAllSelected
          ? {}
          : {
              header: (
                <div className={css.continue}>
                  {i18nGet(
                    i18n,
                    'allOrders.createneworder.sendTemplate_header',
                  )}
                </div>
              ),
            })}
      />,
    );
  };

  const handleDelete = () => {
    modal.error({
      title: i18nGet(i18n, 'allOrders.createneworder.handleDelete_title'),
      content: i18nGet(i18n, 'allOrders.createneworder.handleDelete_content'),
      onOkText: i18nGet(i18n, 'allOrders.createneworder.handleDelete_onOkText'),
      onCancel: () => {
        void 0;
      },
      onCancelText: i18nGet(
        i18n,
        'allOrders.createneworder.handleDelete_onCancelText',
      ),
      onOk: () => {
        _deleteOrder(orderUuid);
      },
    });
  };
  const handlGetFees = (combineData?) => {
    const values = form.getFieldsValue();
    const discountCodes = form.getFieldValue('discountCodes') || [];
    const data = buildData({ ...values, discountCodes });
    _getCreateFees({ ...data, ...combineData });
  };

  const handleUserInfoChange = (value, cb) => {
    //console.log('value', value);
    setHasModified(true);
    cb(value);
  };

  const handleConfirmCustomer = (values) => {
    const data = {
      uuid: orderUuid,
      customerUuids: [get(customer, 'uuid', '')],
      viaEmail: values.sendTo.includes('Email'),
      viaSms: values.sendTo.includes('Mobile'),
      emailTemplateUuid: values.emailTemplate,
      smsTemplateUuid: values.messageTemplate,
    };
    _orderCreateNotify(data);
  };

  const handleNotifyCustomer = () => {
    setWidth(600);
    setShowModal(true);
    setModalTitle(
      getI18n('allOrders.createneworder.viewDetail_topright_notify'),
    );
    setModalContent(
      <SendTemplate
        buyerEmail={customerDetail.buyerEmail}
        buyerPhoneNo={customerDetail.buyerPhoneNo}
        onConfirm={handleConfirmCustomer}
        category={ICategory.CreateOrder}
        onModalCancel={onModalCancel}
        okText={i18nGet(
          i18n,
          'allOrders.createneworder.handleGetFees_onOkText',
        )}
        salesChannelUuid={salesChannelUuid}
      />,
    );
  };

  const overlay = [
    <Menu>
      <MenuItem
        className={css.delete}
        onClick={handleDelete}
        disable={!canDelete}>
        {i18nGet(i18n, 'allOrders.createneworder.menu_delete')}
      </MenuItem>
    </Menu>,
  ];

  //页面左侧主体部分
  const leftGenerate = () => {
    return (
      <Form
        form={form}
        name={formName}
        //监听form表单变化
        onValuesChange={onValuesChange}
        onFinish={onFinish}>
        <Element>
          <SalesChannel
            disable={paymentStatus === IPaymentStatus.PENDING || !canCreate}
            availableLanguage={availableLanguage}
          />
        </Element>
        <Element>
          <Products
            disable={paymentStatus === IPaymentStatus.PENDING || !canCreate}
            currency={get(summary, 'currency')}
            keyUuid='keyUuid'
          />
        </Element>
        <Element>
          {/* <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const value = getFieldValue('discountCodes') || [];
              return <div>{value.join(',')}</div>;
            }}
          </Form.Item> */}
          <Discount
            form={form}
            disable={paymentStatus === IPaymentStatus.PENDING || !canCreate}
            disableApply={!customer}
            currency={get(summary, 'currency')}
            disableDiscountSelections={!customer}
            handleApply={handleApplyDiscount}
            keyUuid='keyUuid'
            decimalPosition={decimalPosition}
            scTimezoneUTC={scTimezoneUTC}
          />
        </Element>
        {(vouchers || []).length && customer ? (
          <Voucher
            disable={paymentStatus === IPaymentStatus.PENDING || !canCreate}
            vouchers={vouchers}
            currency={get(summary, 'currency')}
            scTimezoneUTC={scTimezoneUTC}
          />
        ) : null}
      </Form>
    );
  };
  const products = form.getFieldValue('products') || [];
  return canViewDetail ? (
    <Spin spinning={getCreateOrderDetailLoading}>
      <Layout
        leftPart={leftGenerate()}
        header={
          <div className={css.header}>
            <TopLeft
              goBack={beforeGoBack}
              breadcrumbData={breadcrumbData({ getI18n })}
            />
            <TopRight
              {...(paymentStatus !== IPaymentStatus.PENDING
                ? {
                    onSaveDisable: !hasModified || !canCreate,
                    onDiscard: beforeGoBack,
                    onSubmit: form.submit,
                    extendButton: (
                      <Fragment>
                        <DropDown.Button
                          icon={<Icon type='icondown' />}
                          disabled={!canDelete}
                          className={css.extendButton}
                          overlay={overlay}
                          placement='bottomRight'
                          trigger={['click']}>
                          {i18nGet(
                            i18n,
                            'allOrders.createneworder.viewDetail_topright_dropdownbtn',
                          )}
                        </DropDown.Button>
                        <Button
                          className={css.headerButton}
                          onClick={handlePlaceOrder}
                          disabled={!canPlaceOrder}
                          type='primary'>
                          {getI18n(
                            'allOrders.createneworder.viewDetail_topright_btn',
                          )}
                        </Button>
                      </Fragment>
                    ),
                  }
                : {
                    extendButton: (
                      <Button
                        className={css.headerButton}
                        onClick={handleNotifyCustomer}
                        type='primary'
                        disabled={!canNotifyCustomer}>
                        {getI18n(
                          'allOrders.createneworder.viewDetail_topright_notify',
                        )}
                      </Button>
                    ),
                  })}
            />
          </div>
        }
        rightElements={[
          {
            child: (
              <OrderInfoRight
                title={`${getI18n('allOrders.orderDetail.order')} ${
                  orderNo ? '#' : ''
                }${orderNo || ''}`}
                orderDetail={{
                  status: orderStatus
                    ? [
                        {
                          status: orderStatus,
                          calculate: statusText,
                        },
                        ...(paymentStatus
                          ? [
                              {
                                status: paymentStatus,
                                calculate: paymentStatusText,
                              },
                            ]
                          : []),
                        ,
                      ]
                    : [],
                  productAmount: products.length,
                  subTotal: get(summary, 'formattedSutTotalPrice'),
                  discount: get(summary, 'formattedDiscountPrice'),
                  tax: (get(summary, 'taxes') || []).map((item) => ({
                    name: item.name,
                    value: item.formattedTaxPrice,
                  })),
                  shipping: [
                    {
                      name: shippingName || '-',
                      value: formattedDeliveryFee || '-',
                    },
                  ],
                  total: get(summary, 'formattedTotalPrice'),
                }}
              />
            ),
          },
          {
            child: (
              <Customer
                disabled={!canCreate}
                customer={customer}
                crossBoarder={paymentStatus === IPaymentStatus.PENDING}
                setCustomer={(value) => {
                  handleUserInfoChange(value, setCustomer);
                }}
                salesChannelUuid={salesChannelUuid}
                dbUuid={dbUuid}
                buyerInfo={buyerInfo}
                handleApply={handleApplyDiscount}
                handlGetFees={handlGetFees}
                setBuyerInfo={(value) =>
                  handleUserInfoChange(value, setBuyerInfo)
                }
                customerDetail={customerDetail}
                languageCode={languageCode}
                setCustomerDetail={(value) =>
                  handleUserInfoChange(value, setCustomerDetail)
                }
                parcelSender={parcelSender}
                setParcelSender={(value) =>
                  handleUserInfoChange(value, setParcelSender)
                }
                showInvoice={showInvoice}
                getVouchers={_getVouchers}
                hideOrderInternalRemark
                hideCustomerRemark
                orderUuid={orderUuid}
                buildData={buildCustomerData}
                billingAddressDetail={billingAddressDetail}
                setBillingAddressDetail={(value) =>
                  handleUserInfoChange(value, setBillingAddressDetail)
                }
                recipientInfo={recipientInfo}
                setRecipientInfo={(value) =>
                  handleUserInfoChange(value, setRecipientInfo)
                }
                invoice={invoice}
                setInvoice={setInvoice}
                products={products}
              />
            ),
          },
        ]}
      />
    </Spin>
  ) : (
    <NoPermission />
  );
};

export default ModalHOC(CreateNewOrder);
